import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private apiDomain = environment.FT_HELP_URL_API;

  constructor(private http: HttpClient) { }

  public postFormData(formData: FormData): Observable<string> {
  formData.append('lang', 'no');
  const url = `${this.apiDomain}/contact`;
  return this.http.post(url, formData, { responseType: 'text' });
}

}
